import { AllotmentsView } from '../allotments-view/allotments-view';
import { EmptyView } from '../empty-view/empty-view';
import { FiltersView } from '../filters-view/filters-view';
import { PrivacyView } from '../privacy-view/privacy-view';
import { useAudienceTray } from '../providers/audience-tray-provider';
import { UploadView } from '../upload-view/upload-view';
import { AudienceTabs } from './audience-tabs';

export const AudienceTrayBody = () => {
  const { view } = useAudienceTray();

  switch (view) {
    case 'recipients':
    case 'segments':
    case 'lists':
      return <AudienceTabs />;

    case 'allotments':
      return <AllotmentsView />;

    case 'empty':
      return <EmptyView />;

    case 'filters':
      return <FiltersView />;

    case 'privacy':
      return <PrivacyView />;

    case 'upload':
      return <UploadView />;

    default:
      return null;
  }
};
